import {
  DISABLED_ANIMATION_SLIDE,
  ACTIVATE_ANIMATION_SLIDE
} from "../types/animation.types";

export function activateAnimSlide() {
  return { type: ACTIVATE_ANIMATION_SLIDE };
}

export function disabledAnimSlide() {
  return { type: DISABLED_ANIMATION_SLIDE };
}
